import React from "react"
import PropTypes from "prop-types"
import { Box } from "@infotech/uikit-grid"
import forEach from "lodash/forEach"
import styles from "./styles.css"

const ValidateCounter = ({ validate, totalCount }) => {
  const overCount = totalCount > 99
  let mergeCount = 0
  if (totalCount < 10) {
    mergeCount = 6
  }
  if (totalCount > 9) {
    mergeCount = 3
  }
  let validateType = false
  forEach(validate.eventViolations, value => {
    return forEach(value.violations, validate => {
      if (validate.level === `ERROR`) {
        validateType = true
        return false
      }
      return true
    })
  })
  forEach(validate.resourceViolations, value => {
    return forEach(value.violations, validate => {
      if (validate.level === `ERROR`) {
        validateType = true
        return false
      }
      return true
    })
  })
  return (
    <Box
      w={overCount ? `23px` : `18px`}
      style={{
        borderRadius: overCount ? `40%` : `50%`,
        backgroundColor: validateType ? `#e04a4a` : `#fdd835`,
      }}
      loose
      className={styles.iconCounter}
    >
      <span
        style={{
          marginLeft: `${mergeCount}px`,
        }}
        className={styles.iconCounterText}
      >
        {overCount ? `99+` : totalCount}
      </span>
    </Box>
  )
}

ValidateCounter.propTypes = {
  validate: PropTypes.shape({
    eventViolations: PropTypes.arrayOf(
      PropTypes.shape({
        event: PropTypes.shape({
          endDateTime: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          eventTypeId: PropTypes.number.isRequired,
          planInfo: PropTypes.shape({
            id: PropTypes.number.isRequired,
            locked: PropTypes.bool.isRequired,
            name: PropTypes.string.isRequired,
          }),
          repeatable: PropTypes.bool.isRequired,
          startDateTime: PropTypes.number.isRequired,
          uuid: PropTypes.string.isRequired,
        }),
        violations: PropTypes.arrayOf(
          PropTypes.shape({
            level: PropTypes.string.isRequired,
            message: PropTypes.string.isRequired,
          }),
        ),
      }),
    ),
    planViolations: PropTypes.shape({
      plan: PropTypes.shape({
        startDateTime: PropTypes.number.isRequired,
        endDateTime: PropTypes.number.isRequired,
        id: PropTypes.number.isRequired,
        locked: PropTypes.bool.isRequired,
        name: PropTypes.string.isRequired,
      }),
      violations: PropTypes.arrayOf(
        PropTypes.shape({
          level: PropTypes.string.isRequired,
          message: PropTypes.string.isRequired,
        }),
      ),
    }),
    resourceViolations: PropTypes.arrayOf(
      PropTypes.shape({
        resource: PropTypes.shape({
          description: PropTypes.string.isRequired,
          endDateTime: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          resourceTypeId: PropTypes.number.isRequired,
          planInfo: PropTypes.shape({
            id: PropTypes.number.isRequired,
            locked: PropTypes.bool.isRequired,
            name: PropTypes.string.isRequired,
          }),
          repeatable: PropTypes.bool.isRequired,
          startDateTime: PropTypes.number.isRequired,
          uuid: PropTypes.string.isRequired,
        }),
        violations: PropTypes.arrayOf(
          PropTypes.shape({
            level: PropTypes.string.isRequired,
            message: PropTypes.string.isRequired,
          }),
        ),
      }),
    ),
  }),
  totalCount: PropTypes.number.isRequired,
}
ValidateCounter.defaultProps = {
  validate: [],
}

export default ValidateCounter
